export default "__VITE_ASSET__B1zOs66D__"